/**
 * Minimal route transition placeholder — avoids layout shift while lazy chunks load.
 */
export default function RouteFallback() {
  return <div className="min-h-screen app-page" aria-hidden="true" />;
}
